import React from 'react'
import { Navbar, Nav } from 'react-bootstrap'
import { Link, withRouter } from 'react-router-dom'
import logo from "../../img/ml-pt.svg"
import './style.css'

export default class Header extends React.Component {
  constructor (props) {
    super(props);
    this.state = { navExpanded: false};
    this.setNavExpanded = this.setNavExpanded.bind(this);
    this.closeNav = this.closeNav.bind(this);
  }

  setNavExpanded(expanded) {
    this.setState({ navExpanded: expanded });
  }

  closeNav() {
    console.log('called');
    this.setState({ navExpanded: false });
  }


  render () {
    return (
      <Navbar
        onToggle={this.setNavExpanded}
        expanded={this.state.navExpanded}
        className={'top-menu'}
        fixedTop={true}
        style={{
            "boxShadow": "-1px 6px 20px 2px whitesmoke"
        }}
      >
        <Navbar.Header>
          <Navbar.Brand>
            <Link to={'/'}>
              <img src={logo} style={{"padding": "5px", "marginTop": "-17px"}} alt="Logo"></img>
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <CustomNav  onClick={this.closeNav}/>
          </Navbar.Collapse>
      </Navbar>
    )
  }
}

const HelpDropdown = (location) => {
  return (
      <li className={(location.pathname.startsWith("/help")) ? "active nav-item dropdown" : "dropdown nav-item"}>
        <a href="/help">Help</a>
        <div className="dropdown">
          <div className="dropdown-content">
            <Link className="nav-link dropdown" to="/self-help">Self Help</Link>
            <Link className="nav-link dropdown" to="/help-from-others">Help from Others</Link>
          </div>
        </div>
      </li>
  );
}




const CustomNav = withRouter((props) => {
  const { location } = props;

  if(location.pathname.startsWith("/admin")) {
    return (
        <Nav pullRight onClick={props.onClick}>
          <li className="nav-item"><Link className="nav-link" to="/">Return to MindAid</Link></li>
        </Nav>
    )
  } else if(location.pathname.startsWith("/youth")) {
    return (
        <Nav pullRight onClick={props.onClick}>
          <li className={(location.pathname.startsWith("/youth/talk")) ? "active nav-item" : "nav-item"}>
            <Link className="nav-link" to="/youth/talk" onClick={() => {
              this.props.location = '/youth/talk';
              window.location.reload();
            }}>Talk</Link>
          </li>
          <li className={(location.pathname.startsWith("/youth/quiz")) ? "active nav-item" : "nav-item"}>
            <Link className="nav-link" to="/youth/quiz" onClick={() => {
              this.props.location = '/youth/quiz';
              window.location.reload();
            }}>Quiz</Link>
          </li>
          <li className={(location.pathname.startsWith("/youth/library")) ? "active nav-item" : "nav-item"}>
            <Link className="nav-link" to="/youth/library" onClick={() => {
              this.props.location = '/youth/library';
              window.location.reload();
            }}>Library</Link>
          </li>
          {HelpDropdown(location)}
        </Nav>
    )
  } else if(location.pathname.startsWith('/teacher')){
    return(
        <Nav pullRight onClick={props.onClick}>
          <li className={"nav-item"} >
            <Link className="nav-link" to="/">Home</Link>
          </li>
          <li className={(location.pathname.startsWith("/about")) ? "active nav-item":"nav-item"} >
            <Link className="nav-link" to="/about">About</Link>
          </li>
          <li className={(location.pathname.startsWith("/teacher/listen")) ? "active nav-item":"nav-item"} >
            <Link className="nav-link" to="/teacher/listen" onClick={()=>{
              this.props.location = '/teacher/listen';
              window.location.reload();
            }}>Listen</Link>
          </li>
          <li className={(location.pathname.startsWith("/teacher/screen")) ? "active nav-item":"nav-item"} >
            <Link className="nav-link" to="/teacher/screen" onClick={()=>{
              this.props.location = '/teacher/screen';
              window.location.reload();
            }}>Question</Link>
          </li>
          <li className={(location.pathname.startsWith("/teacher/learn")) ? "active nav-item":"nav-item"} >
            <Link className="nav-link" to="/teacher/learn" onClick={()=>{
              this.props.location = '/teacher/learn';
              window.location.reload();
            }}>Learn</Link>
          </li>
          {HelpDropdown(location)}
        </Nav>
    )
  } else {
    return (
      <Nav pullRight onClick={props.onClick}>
        <li className={(location.pathname.startsWith("/about"))?"active nav-item":"nav-item"} >
          <Link className="nav-link" to="/about">About</Link>
        </li>
        <li className={(location.pathname.startsWith("/teacher"))?"active nav-item":"nav-item"} >
          <Link className="nav-link" to="/teacher">Teacher</Link>
        </li>
        <li className={(location.pathname.startsWith("/youth"))?"active nav-item":"nav-item"} >
          <Link className="nav-link" to="/youth" onClick={()=>{
            this.props.location = '/youth';
            window.location.reload();
          }}>Youth</Link>
        </li>
        {HelpDropdown(location)}
      </Nav>
    )
  }

});



// WEBPACK FOOTER //
// ./src/components/Header/index.js